import { useEffect, useMemo, useState } from "react";
import { Button } from "../../components/ui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useFormatDateTime } from "../../hooks/date";
import { UserTransaction, UserTransactionResponse } from "../../rest/defs";
import { CurrentSessionData } from "../../hooks/userSession";
import { authFetch } from "../../rest/authFetch";
import RestrictedAccess from "../../components/RestrictedAccess";

export interface BalanceItem {
  date: string;
  purchase: string;
  exchange: string;
  balance: string;
}

const TransactionList = ({
  currentSession,
}: {
  currentSession: CurrentSessionData;
}) => {
  const [transactionList, setTransactionList] = useState<BalanceItem[]>([]);

  const params = useParams();
  const navigate = useNavigate();

  const formatDateTime = useFormatDateTime();

  const toBalance = (items: UserTransaction[]) => {
    const fmt = (value: number) => Number(value).toFixed(2);

    let balance = 0.0;
    return items.map((item) => {
      const isExchange = item.type === "exchange";

      const value = isExchange ? item.amount / item.exchange_rate : item.amount;
      const strValue = fmt(value) + " puntos";
      balance += value * (isExchange ? -1 : 1);
      return {
        date: item.transaction_dt,
        purchase: !isExchange ? strValue : "",
        exchange: isExchange ? strValue : "",
        balance: fmt(balance),
      };
    });
  };

  const transactionsUrl = useMemo(
    () =>
      `${process.env.REACT_APP_API_BASE_URL}/transaction/search/q?customerId=${params.id}`,
    [params.id]
  );

  useEffect(() => {
    authFetch(transactionsUrl)
      .then((response) => response.json())
      .then((result: UserTransactionResponse) =>
        setTransactionList(toBalance(result.data))
      );
  }, [transactionsUrl]);

  return (
    <RestrictedAccess currentSession={currentSession}>
      <div className="space-y-4">
        <strong>Movimientos de la cuenta:</strong>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b text-left">
                <th className="p-2 font-medium">Fecha</th>
                <th className="p-2 font-medium">Abono</th>
                <th className="p-2 font-medium">Cargo</th>
                <th className="p-2 font-medium">Saldo</th>
              </tr>
            </thead>
            <tbody>
              {transactionList.map((item) => (
                <tr key={item.date} className="border-b hover:bg-muted/50">
                  <td className="p-2">
                    <small>{formatDateTime(item.date)}</small>
                  </td>
                  <td className="p-2">{item.purchase}</td>
                  <td className="p-2">{item.exchange}</td>
                  <td className="p-2">
                    <strong>{item.balance} puntos</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-center">
          <Button onClick={() => navigate("/")}>Regresar</Button>
        </div>
      </div>
    </RestrictedAccess>
  );
};

export default TransactionList;
